import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ECommerce3DSAuthenticationRequest,
  ECommerce3DSRedirectResponse,
  ECommerceAppleCardTokenRequest,
  ECommerceBaseResponse,
  ECommerceCardTokenRequest,
  ECommerceMultipleCardTokensRequest,
  ECommercePaymentRequest,
  ECommercePaymentResponse,
  GoogleCardTokenizationRequest,
  GooglePayProperties,
} from './api.models';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private readonly BASE = environment.TPS_API;

  constructor(private http: HttpClient) {}

  doPanTokenGeneration(transactionId: string, requestDetails: ECommerceCardTokenRequest) {
    const requestUri = this.BASE + '/ecomm/cards/token/' + transactionId;
    return this.http.post<ECommerceBaseResponse>(requestUri, requestDetails);
  }

  doMultiplePanTokenGeneration(transactionId: string, requestDetails: ECommerceMultipleCardTokensRequest) {
    const requestUri = this.BASE + `/ecomm/cards/token/${transactionId}/multiple`;
    return this.http.post<ECommerceBaseResponse>(requestUri, requestDetails);
  }

  send3DSAuthRequest(companyId: string, requestType: string, request: ECommerce3DSAuthenticationRequest) {
    const requestUri = this.BASE + `/ecomm/company/${companyId}/3ds/auth-request/${requestType}`;
    return this.http.post<ECommerce3DSRedirectResponse>(requestUri, request);
  }

  doEcommercePayment(transactionId: string, paymentDetails: ECommercePaymentRequest) {
    const requestUri = this.BASE + '/ecomm/payment/' + transactionId;
    return this.http.put<ECommercePaymentResponse>(requestUri, paymentDetails);
  }

  getAppleValidationObject() {
    const requestUri = this.BASE + '/ecomm/apple/validate-merchant';
    return this.http.get<object>(requestUri);
  }

  tokenizeFromApplePayPayment(transactionId: string, request: ECommerceAppleCardTokenRequest) {    
    const requestUri = `${this.BASE}/ecomm/apple/tokenize-card/${transactionId}`;
    return this.http.post<ECommercePaymentResponse>(requestUri, request);
  }

  getGoogleProperties() {
    const requestUri = this.BASE + '/ecomm/google/properties';
    return this.http.get<GooglePayProperties>(requestUri);
  }

  tokenizeFromGooglePayment(transactionId: string, request: GoogleCardTokenizationRequest) {
    const requestUri = `${this.BASE}/ecomm/google/tokenize-card/${transactionId}`;
    return this.http.post<ECommercePaymentResponse>(requestUri, request);
  }
}
